var _path;

import * as React from "react";

function SvgChartBar(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 26h1.4c.4 0 .8-.4.8-.8V10.8c0-.4-.4-.8-.8-.8h-1.4c-.4 0-.8.4-.8.8v14.4c0 .4.4.8.8.8zm-12 0h1.4c.4 0 .8-.4.8-.8V12.8c0-.4-.4-.8-.8-.8h-1.4c-.4 0-.8.4-.8.8v12.4c0 .4.4.8.8.8zm6 0h1.4c.4 0 .8-.4.8-.8v-8.4c0-.4-.4-.8-.8-.8h-1.4c-.4 0-.8.4-.8.8v8.4c0 .4.4.8.8.8zM35 29H7V9a1 1 0 00-1-1H5a1 1 0 00-1 1v21a2 2 0 002 2h29a1 1 0 001-1v-1a1 1 0 00-1-1zm-24.2-3h1.4c.4 0 .8-.4.8-.8v-4.4c0-.4-.4-.8-.8-.8h-1.4c-.4 0-.8.4-.8.8v4.4c0 .4.4.8.8.8z"
  })));
}

export default SvgChartBar;